<div class="page-container">

  <div class="container">

    <div class="gallery-page-content" *ngIf="selectedReference">

      <app-reference-preview [referencePage]="true" [reference]="selectedReference"></app-reference-preview>

      <app-html-editor-wrapper
        [editMode]="false"
        [showButtons]="false" *ngIf="selectedReference.body"
        [value]="selectedReference.body">
      </app-html-editor-wrapper>


      <div class="masonry-grid">

        <app-gallery-grid

          [items]="galleryGridItems"
          [columns]="gridColumnCount"
          (elementClick)="gridElementClicked($event)"
        >
        </app-gallery-grid>
      </div>


    </div>
  </div>

</div>


<ng-image-fullscreen-view
  [images]="galleryImageList"
  [imageIndex]="selectedImageIndex"
  [show]="showFlag"
  (close)="closeEventHandler()"></ng-image-fullscreen-view>

